import { useState, useEffect } from "react";
import services from "commons/apis/index";

const useGetAllProject = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const { items } = await services.getProjects({ count: 100, page: 0 });
        setData(items);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return {
    data: data ?? [],
    loading,
  };
};
export default useGetAllProject;
